import React from 'react'
import PropTypes from 'prop-types'
import { useChameleon } from '../hooks/useChameleon'

/**
 * AppWrapper component that initializes Chameleon.io for user tracking.
 * Wrap view components with this to enable Chameleon integration.
 */
export function AppWrapper({ children, currentUser, chameleonHash }) {
  useChameleon(currentUser, chameleonHash)
  return <>{children}</>
}

AppWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  currentUser: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  chameleonHash: PropTypes.string,
}

AppWrapper.defaultProps = {
  currentUser: null,
  chameleonHash: null,
}

export default AppWrapper
